import React, { useEffect } from "react";
import styled from "styled-components";
import AdminTabs from "../../../components/AdminCentral/Admins/AdminTabs";
import AdminsContent from "../../../components/AdminCentral/Admins/AdminsContent";
import SubmitQuoteContent from "../../../components/AdminCentral/Admins/SubmitQuoteContent";
import QuotesContent from "../../../components/AdminCentral/Admins/QuotesContent";
import usePersistentTabState from "../../../hooks/usePersistentTabState";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
    @media (max-width: ${breakpoints.tablet}px) {
    width: 750px;
    padding: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 450px;
    // padding: 12px;
    margin: 0 auto;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground}; 
  @media (max-width: ${breakpoints.tablet}px) {
    width: 750px;
    padding: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 400px;
    // padding: 12px;
    margin: 0 auto;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const Title = styled.text`
 font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px; 

  span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const TABS = ["Administrators", "Submit Quotes", "Quotes"];

const AdminsPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.admins.selectedTab",
    TABS[0]
  );

  useEffect(() => {
    if (!TABS.includes(selectedTab)) {
      setSelectedTab(TABS[0]);
    }
  }, [selectedTab, setSelectedTab]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
    <Title colors={colors}> Administrators </Title>
    <Container colors={colors}>
      <AdminTabs colors={colors} selectedTab={selectedTab} handleTabClick={handleTabClick} />
      {selectedTab === "Administrators" && <AdminsContent colors={colors} />}
      {selectedTab === "Submit Quotes" && <SubmitQuoteContent colors={colors} />}
      {selectedTab === "Quotes" && <QuotesContent colors={colors} />}
    </Container>
    </DashboardContainer>
  );
};

export default AdminsPage;
